// extracted by mini-css-extract-plugin
module.exports = {"comment":"TruncatedCommentaire_comment__xZsiB","btnExpand":"TruncatedCommentaire_btnExpand__3KYf_","rotate":"TruncatedCommentaire_rotate__20ESf"};